export const percentageCalc = (partialValue, totalValue) => {
  if (totalValue === 0 || totalValue === null) {
    return 0;
  }
  return Math.round((partialValue === null ? 0 : partialValue / totalValue) * 100);
};
